import { render, staticRenderFns } from "./productquestion.vue?vue&type=template&id=7717ddaa&scoped=true&"
import script from "./productquestion.vue?vue&type=script&lang=js&"
export * from "./productquestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7717ddaa",
  null
  
)

export default component.exports